import React from "react";
import { FormHelperText, styled } from "@mui/material";
import { CloseIcon } from "../../../atoms/icons/close";

export const FormHelperStyledError = styled(FormHelperText)({
  color: "orange !important",
  fontWeight: "bold",
  marginLeft: 0,
  marginRight: 0,
});

export const PieChartContainer = styled("div")({
  width: "132px",
});

export const PieChartMobileContainer = styled("div")({
  width: "82px",
});

export const PieChartDetailsContainer = styled("div")({
  width: "132px",
  margin: "20px 0 0 0",
});

export const PieChartDetailsMobileContainer = styled("div")({
  width: "108px",
  margin: "20px",
});

export const SubtitleSpan = styled("span")({
  fontWeight: "bold",
});

export const PrincipalContainer = styled("span")({
  color: "#205590",
  textAlign: "right",
});

export const InterestContainer = styled("span")({
  color: "#e7174b",
  textAlign: "right",
});

export const PmiContainer = styled("span")({
  color: "#600e2a",
  textAlign: "right",
  position: "relative"
});

export const PmiTooltipPositioner = styled("div")({
  position: 'absolute',
  top: -4,
  right: 98,
});

export const TooltipDataMobileCardPositioner = styled("div")({
  position: 'absolute',
  top: 90,
  right: 51,
});

export const InsuranceContainer = styled("span")({
  color: "#3a9ed7",
  textAlign: "right",
});

export const TaxesContainer = styled("span")({
  color: "#666666",
  textAlign: "right",
});

export const PrincipalDesktopContainer = styled("span")({
  color: "#205590",
  textAlign: "right",
  fontSize: "1.8em",
});

export const InterestDesktopContainer = styled("span")({
  color: "#e7174b",
  textAlign: "right",
  fontSize: "1.8em",
});

export const PmiDesktopContainer = styled("span")({
  color: "#600e2a",
  textAlign: "right",
  fontSize: "1.8em",
});

export const InsuranceDesktopContainer = styled("span")({
  color: "#3a9ed7",
  textAlign: "right",
  fontSize: "1.8em",
});

export const TaxesDesktopContainer = styled("span")({
  color: "#666666",
  textAlign: "right",
  fontSize: "1.8em",
});

export const PrincipalDetailsContainer = styled("span")({
  color: "#205590",
  textAlign: "left",
  fontWeight: "bold",
});

export const InterestDetailsContainer = styled("span")({
  color: "#e7174b",
  textAlign: "left",
  fontWeight: "bold",
});

export const PmiDetailsContainer = styled("span")({
  color: "#600e2a",
  textAlign: "left",
  fontWeight: "bold",
});

export const InsuranceDetailsContainer = styled("span")({
  color: "#3a9ed7",
  textAlign: "left",
  fontWeight: "bold",
});

export const TaxesDetailsContainer = styled("span")({
  color: "#666666",
  textAlign: "left",
  fontWeight: "bold",
});

export const PdfContainer = styled("div")({
  display: "none",
});

export const RemoveQuoteContainer = styled("div")({
  color: "white",
  fontWeight: "bold",
});

export const CloseIconMobile = styled(CloseIcon)({
  marginBottom: "-8px",
});
